import styled from '@emotion/styled';

import { PrimaryTableRowDotted } from '@Calix-Commerce/design-system/components';

export const TableRowDotted = styled(PrimaryTableRowDotted)`
  td {
    width: 20%;

    & > div {
      padding-right: 1rem;
    }
  }
`;

export const TableStatus = styled.div`
  margin: 1rem auto;
  font-size: 1.1rem;
  text-align: center;
  max-width: 60%;
`;
